import { Outlet } from 'react-router';
import { MainLayout } from '@/components/Layouts/MainLayout/MainLayout';

const AccountLayout = () => (
  <MainLayout>
    <Outlet />
  </MainLayout>
);

export default AccountLayout;
